module.exports = __webpack_public_path__ + "static/back-dots-93dc38faaac371377f1fceafbb0707aa.svg";